import React from "react";
import { clientHistory } from "../../utils/enum/enums";

const HistoryFormFields = ({
  type,
  amount,
  depositType,
  setAmount,
  setDepositType,
  depositTypes,
  translate,
}) => {
  if (type !== clientHistory.DEPOSIT) return null;

  return (
    <>
      <div>
        <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
          {translate("deposit-type")}
        </label>
        <select
          value={depositType}
          onChange={(e) => setDepositType(e.target.value)}
          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg w-full p-2.5 dark:bg-gray-700 dark:text-white"
        >
          {depositTypes.map((deposit) => (
            <option key={deposit._id} value={deposit.code}>
              {deposit.name}
            </option>
          ))}
        </select>
      </div>
      <div>
        <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
          {translate("amount")}
        </label>
        <input
          type="number"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          placeholder={translate("amount")}
          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg w-full p-2.5 dark:bg-gray-700 dark:text-white"
        />
      </div>
    </>
  );
};

export default HistoryFormFields;
